import { Button, Col, Row } from "antd";
import React from "react";
import { ComponentTitle, PageTitleLastCol, SearchForm } from "../custom-components";
import { CustomTable } from "../series/StyledComponent";
import useStationsListHook from "./hooks/useStationsListHook";
import useScreenSizeHook from "../utils/useScreenSizeHook";
import StationForm from "./modals/StationForm";

const StationsListComponent: React.FC = () => {
	const { height } = useScreenSizeHook();
	const {
		stationsListColumns,
		form,
		searchData,
		saveUpdateStationsList,
		isStationFormOpen,
		setIsStationFormOpen,
		handleCancel,
		isLoading,
		stationEditId,
		stationsListData,
	} = useStationsListHook();
	return (
		<>
			<Row justify="space-between" align="middle">
				<Col>
					<ComponentTitle>Stations List</ComponentTitle>
				</Col>
				<PageTitleLastCol>
					<Button type="primary" onClick={() => setIsStationFormOpen(true)}>
						+ Add Station
					</Button>
					<SearchForm form={form} searchData={searchData} placeholder="Search by List Name" />
				</PageTitleLastCol>
			</Row>
			<CustomTable
				scroll={{ y: height - 265 }}
				columns={stationsListColumns}
				dataSource={stationsListData}
				pagination={false}
				loading={isLoading}
			/>
			<StationForm
				form={form}
				submitHandler={saveUpdateStationsList}
				onCancel={handleCancel}
				isLoading={isLoading}
				stationEditId={stationEditId}
				isOpen={isStationFormOpen}
			/>
		</>
	);
};

export default StationsListComponent;
